/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    name: "centrelinkCardTitle",
    label: "Centrelink concession card"
  },
  {
    fieldType: FIELD.TEXT.PARAGRAPH,
    name: "centrelinkCardIntroduction",
    description: [
      "Enter all fields exactly as they appear on your Centrelink concession card."
    ]
  },
  {
    fieldType: FIELD.INPUT.RADIO,
    name: "greenid_centrelinkdvs_cardType",
    label: "Card type",
    halfWidth: true,
    fieldRequired: true,
    options: [
      { text: "Pensioner concession card (PCC)", value: "PCC" },
      { text: "Health care card (HCC)", value: "HCC" },
      { text: "Seniors health card (SHC)", value: "SHC" }
    ]
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_centrelinkdvs_number",
    label: "Customer Reference Number (CRN)",
    fieldRequired: true,
    validation: { required: true, regex: /^\d{9}[A-Za-z]{1}$/ },
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_centrelinkdvs_nameOnCard",
    label: "Full name",
    fieldRequired: true,
    validation: { required: true, max: 32, regex: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/ },
    hint: "Enter exactly as it appears on your card (e.g. Helen Chan)."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_centrelinkdvs_dob",
    label: "Date of birth",
    disabled: true,
    hint: "For example, 31 3 1979",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2021
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Expiry date",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_centrelinkdvs_expiry",
    label: "Expiry date",
    hint: "For example, 12 9 2022",
    validation: { required: true },
    fromYear: new Date().getFullYear(),
    toYear: 2030
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "greenid_centrelinkdvs_tandc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: "on",
        text: "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity."
      }
    ]
  }
];
